export enum Season {
  WINTER,
  SUMMER,
}